import React, { useContext } from 'react';
import classNames from 'classnames';
import EnterpriseNavigation from '../../components/EnterpriseNavigation';
import EnterpriseContext from '../../providers/Enterprise/Enterprise.context';
import EnterpriseConfigureWrapper from 'components/EnterpriseConfigureWrapper';

import './Configuration.styles.scss';

type ConfigurationProps = {
  className?: string;
};

const Configuration: React.FC<ConfigurationProps> = (props) => {
  const { className } = props;

  const {
    enterprise,
    updateBusinessUnits,
    updateMemberSeniorities,
    updateMemberLocations,
  } = useContext(EnterpriseContext);

  const classes = classNames('configuration', className);

  return (
    <div className={classes}>
      <EnterpriseNavigation />
      <EnterpriseConfigureWrapper
        enterprise={enterprise}
        updateBusinessUnits={updateBusinessUnits}
        updateMemberSeniorities={updateMemberSeniorities}
        updateMemberLocations={updateMemberLocations}
      />
    </div>
  );
};

export default Configuration;
